import { render } from "./bufa.vue?vue&type=template&id=8dbe4078&scoped=true"
import script from "./bufa.vue?vue&type=script&lang=js"
export * from "./bufa.vue?vue&type=script&lang=js"

import "./bufa.vue?vue&type=style&index=0&id=8dbe4078&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dbe4078"]])

export default __exports__